import { j as r } from "../../../node_modules/react/jsx-runtime.js";
const p = ({ width: s = 0, height: t = "100%", style: e, ...o }) => /* @__PURE__ */ r.jsx(
  "div",
  {
    ...o,
    style: { ...e, width: s, height: t }
  }
);
export {
  p as default
};
//# sourceMappingURL=Spacer.js.map
